// extracted by mini-css-extract-plugin
module.exports = {"container":"Toast_container__1Fwb_","heading":"Toast_heading__3tLvd","headingText":"Toast_headingText__3JKqi","time":"Toast_time__3i2uA","message":"Toast_message__2C7SP"};